import React, {Component} from 'react';
import {connect} from 'react-redux';
import {
  getFolderList,
  getMindfileItemLocationsPublic as getMindfileItemLocations,
  getMindfileItemPublic as getMindfileItem,
  getMindfileItemsDetails,
  getMindfileItemsPublic as getMindfileItems,
  setSelectedItems,
  updateItemViewCountPublic as updateItemViewCount
} from '../../../../state/actions/getDataActions';
import {getFilterValues} from '../../../../state/actions/getFilterDataActions';
import {addFolder, moveItems, removeItems} from '../../../../state/actions/updateDataActions';
import {
  bemeCell,
  createdCell,
  dateCell,
  descriptionCell,
  emotionCell,
  extensionCell,
  fieldCell,
  fieldCellDateTime,
  fieldCellSm,
  folderNameCell,
  formatItemDataType,
  iconCell,
  keywordsCell,
  locationCell,
  nameCell,
  peopleCell,
  sharingCell,
  sizeCell,
  sourceCell,
  typeCell,
  updatedCell
} from './list-view/ItemCells';
import ItemsPage from './table/ItemsPage';
import BindViewOptions from "../../../util/data-table/BindViewOptions";
import {Avatar} from "@material-ui/core";
import {API_ROOT} from "../../../../baseUrls";
import {formatDateTime} from "../../../../helpers/FormatUtils";
import {SpacecastIcon} from "../../../../helpers/Icons";
import ToolbarButton from "../../../../helpers/ToolbarButton";

class SpacecastGlobalExplorer extends Component {

  filterDefinitions = [
    { label: "Status", key: "status", enabled: false, visible: true, options: (opts) => [{name:'Active', value: 1}, {name: 'Pending', value: 0}] },
    { label: "Keywords", key: "keywords", enabled: false, visible: true, options: (opts) => opts ? (opts.keywords || []).map((k) => ({value: k.id, name: k.text})) : [] },
    { label: "People", key: "people", enabled: false, visible: true, options: (opts) => opts ? (opts.people || []).map((p) => ({value: p.id, name: p.name})) : [] },
    { label: "Folders", key: "folders", enabled: false, visible: true, options: (opts) => opts ? (opts.folders || []).map((f) => ({value: f.id, name: f.name})) : [] },
    { label: "Emotions", key: "emotions", enabled: false, visible: true, options: (opts) => opts ? (opts.emotions || []).map((e) => ({value: e, name: e})) : [] },
    { label: "Bemes", key: "bemes", enabled: false, visible: true, options: (opts) => opts ? (opts.bemes || []).map((e) => ({value: e, name: e})) : [] },
    { label: "Item Types", key: "item_data_types", enabled: false, visible: true, options: (opts) => opts ? (opts.item_data_types || []).map((e) => ({value: e, name: formatItemDataType(e)})) : [] },
    { label: "File Type", key: "upload_types", enabled: true, visible: true, options: (opts) => opts ? (opts.upload_types || []).map((e) => ({value: e, name: e.charAt(0).toUpperCase() + e.slice(1)})) : [] },
    { label: "Spacecast", key: "spacecast", enabled: false, visible: true, options: (opts) => [{name:'Enabled', value: 1}, {name: 'Disabled', value: 0}] },
  ];

  columns = [
    // {key: 'selected', header: {label: '', sort: null }, cell: selectCell, enabled: true},
    {key: 'mindfile', header: { label: 'Mindfile', sort: "mindfiles.name" }, cell: fieldCell(item => item.mindfile_name ?
        <div style={{display:"flex", alignItems:'center', gap:'0.5rem'}}>
          <Avatar
            alt={item.mindfile_name}
            src={`${API_ROOT}/mindfiles/${item.mindfile_id}/avatar/thumbnail?size=48&ts=${item.mindfile_ts}`}
            style={{ border: "2px solid #003e58", width:'36px', height:'36px'}}
          />
          <div style={{textOverflow:'ellipsis', overflow:"hidden"}}>{item.mindfile_name}</div>
        </div> : null), enabled: true },
    {key: 'type', header: [
        { label: 'Type', sort: 'uploads.gross_type' },
      ], cell: typeCell, enabled: true },
    {key: 'icon', header: {label: '', sort: null }, cell: iconCell, enabled: true },
    {key: 'name', header: { label: 'Name', sort: 'mindfile_items.name' }, cell: nameCell, enabled: true },
    {key: 'description', header: { label: 'Description', sort: 'mindfile_items.description', nulls: true }, cell: descriptionCell, enabled: false },
    {key: 'date', header: { label: 'Date', sort: 'mindfile_items.date', asc: false, nulls: true }, cell: dateCell, enabled: false },
    {key: 'location', header: [
        { label: 'Location', sort: 'locations.country', nulls: true },
        {label:'Latitude', shortLabel: 'Lat', sort: 'locations.latitude', nulls: true },
        {label:'Longitude', shortLabel: 'Lng', sort: 'locations.longitude', nulls: true },
      ], cell: locationCell, enabled: false },
    {key: 'keywords', header: { label: 'Keywords', sort: 'keywords.text', asc: false, nulls: true }, cell: keywordsCell, enabled: false},
    {key: 'people', header: { label: 'People', sort: 'people.name', asc: false, nulls: true }, cell: peopleCell, enabled: false},
    {key: 'emotion', header: { label: 'Emotion', sort: 'mindfile_items.emotion', nulls: true }, cell: emotionCell, enabled: false},
    {key: 'beme', header: { label: 'Beme', sort: 'mindfile_items.beme', nulls: true }, cell: bemeCell, enabled: false},
    {key: 'created', header: { label: 'Added', sort: 'mindfile_items.created_at', asc: false }, cell: createdCell, enabled: false, viewHidden: true },
    {key: 'updated', header: { label: 'Modified', sort: 'mindfile_items.updated_at', asc: false }, cell: updatedCell, enabled: false, viewHidden: true },
    {key: 'sharing', header: { label: 'Sharing', sort: 'mindfile_items.sharing' }, cell: sharingCell, enabled: false },
    // {key: 'spacecast', header: { label: "Spacecast", shortLabel:<SpacecastIcon />, sort: 'spacecast_uploads.id', asc: false, size:"small" }, cell: spacecastCell, enabled: true },
    {key: 'spacecast_first', header:{ label: 'First Spacecast', sort: 'spacecast_uploads.spacecast_start', asc: false },
      cell: fieldCellDateTime(item => item.spacecast_upload?.spacecast_start || null),
      viewText: (item,classes) => formatDateTime("spacecastFirstCell", item.spacecast_upload?.spacecast_start, classes), viewPlacement: "tags",
      enabled: true },
    {key: 'spacecast_dist_first', header:{ label: 'First Distance', sort: 'spacecast_uploads.spacecast_start', asc: false, size:"normal" },
      cell: fieldCellSm(item => item.spacecast_upload?.distance_start || null),
      viewText: (item,classes) => item.spacecast_upload?.distance_start || "", viewPlacement: "tags",
      enabled: true },
    {key: 'spacecast_last', header:{ label: 'Last Spacecast', sort: 'spacecast_uploads.spacecast_at', asc: false },
      cell: fieldCellDateTime(item => item.spacecast_upload?.spacecast_at || null),
      viewText: (item,classes) => formatDateTime("spacecastLastCell", item.spacecast_upload?.spacecast_at, classes), viewPlacement: "tags",
      enabled: true },
    {key: 'spacecast_dist_last', header:{ label: 'Last Distance', sort: 'spacecast_uploads.spacecast_at', asc: false, size:"normal" },
      cell: fieldCellSm(item => item.spacecast_upload?.distance || null),
      viewText: (item,classes) => item.spacecast_upload?.distance || "", viewPlacement: "tags",
      enabled: true },
    {key: 'spacecast_count', header:{ label: 'Spacecasts Count', shortLabel:"Casts", sort: 'spacecast_uploads.spacecast_count', asc: false, size:"normal" },
      cell: fieldCellSm(item => item.spacecast_upload?.spacecast_count || null),
      viewText: (item,classes) => item.spacecast_upload?.spacecast_count || "", viewPlacement: "tags",
      enabled: true },
    {key: 'rightAscension', header:  [
        {label:'Right Ascension', shortLabel: 'Right Asc', sort: 'spacecast_uploads.ra', nulls: true, size:"small" },
        {label:'Declination', shortLabel: 'Declination', sort: 'spacecast_uploads.dec', nulls: true },
      ],
      cell: fieldCellSm(item => [item.spacecast_upload?.right_ascension, item.spacecast_upload?.declination].filter(x => !!x).join(", ")),
      viewText: (item,classes) => [item.spacecast_upload?.right_ascension, item.spacecast_upload?.declination].filter(x => !!x).join(", "), viewHidden: true,
      enabled: true, hidden: false },
    {key: 'rightAscensionView', header:  {label:'Right Ascension', shortLabel: 'Right Asc', sort: 'spacecast_uploads.ra', nulls: true, size:"small" }, d:{label:'Declination', shortLabel: 'Declination', sort: 'spacecast_uploads.dec', nulls: true },
      cell: fieldCellSm(item => item.spacecast_upload?.right_ascension || ""),
      viewText:(item,classes) => item.spacecast_upload?.right_ascension || "", viewPlacement: "tags",
      enabled: false, hidden: false },
    {key: 'declinationView', header:  {label:'Declination', sort: 'spacecast_uploads.dec', nulls: true, size:"small" }, d:{label:'Declination', shortLabel: 'Declination', sort: 'spacecast_uploads.dec', nulls: true },
      cell: fieldCellSm(item => item.spacecast_upload?.declination || ""),
      viewText:(item,classes) => item.spacecast_upload?.declination || "", viewPlacement: "tags",
      enabled: false, hidden: false },
    {key: 'extension', header:  {label:'Extension', shortLabel: 'Ext', sort: 'uploads.extension', nulls: true }, cell: extensionCell, enabled: true, hidden: false },
    {key: 'size', header: { label: 'Size', sort: 'uploads.size', asc: false, nulls: true }, cell: sizeCell, enabled: true, hidden: false },
    {key: 'source', header: { label: 'Source', sort: 'uploads.source', nulls: true }, cell: sourceCell, enabled: false, hidden: true, viewHidden: true },
    {key: 'folderName', header: { label: 'Folder', sort: 'folders.name' }, cell: folderNameCell, enabled: false, action: false, viewHidden: true },
    {key: 'openSpacecast', header: { label: 'View Spacecast', sort: null }, cell: fieldCell(item =>
        <ToolbarButton
          id="openSpacecastBtn"
          label="Spacecast"
          startIcon={<SpacecastIcon />}
          onClick={() => {
            if(this.props.viewItem === null || this.props.viewItem.id !== item.id || this.props.viewItem.url_ts < item.url_ts || !this.props.viewItem.spacecasts){
              this.props.getMindfileItem(item.mindfile_id, item.id, false, () => {
                this.props.history.push(`/explore/spacecast3d`)
              })
            }else{
              this.props.history.push(`/explore/spacecast3d`)
            }
          }}
        />
      ), enabled: true, action: false, viewHidden: false },
  ];

  filters = this.filterDefinitions.map((filter, index) => ({
    ...filter, index: index, handleSelect: this.handleFilterSelect.bind(this, index), addFilterSelect: this.addFilterSelect.bind(this, index)
  }));

  defaultViewOpts = {
    rowsPerPage: 12,
    orders: [{f: 'spacecast_uploads.spacecast_at', d: false, n: true}],
    viewMode: 'List',
    iconSize: 'Medium',
    visibleColumns: Object.assign({}, ...this.columns.filter(col => col.enabled).map(c => ({[c.key]: !c.hidden}))),
  };

  defaultFilters = (filters) => [
    { key: "status", selectedItems: [], },
    { key: "keywords", selectedItems: [], },
    { key: "people", selectedItems: [], },
    { key: "folders", selectedItems: [], },
    { key: "emotions", selectedItems: [], },
    { key: "bemes", selectedItems: [], },
    { key: "item_data_types", selectedItems: [], },
    { key: "upload_types", selectedItems: [], },
    { key: "spacecast", selectedItems: [], },
  ];

  state = {
    pageKey: "/explore/spacecast/global",
    title: "Spacecast Global Log",
    loading: true,
    viewOptsLoaded: false,
    controller: {
      page: 1,
      rowsPerPage: this.defaultViewOpts.rowsPerPage,
      orders: this.defaultViewOpts.orders,
      search: null,
    },
    mapBounds: null,
    items: [],
    filter_count: 0,
    folderList: [],
    filterSelections: this.defaultFilters(),
    selectedIds: [],
    // selectedItems: {},
    tableView: {
      addButtons: [],
      viewMode: this.defaultViewOpts.viewMode,
      viewModeOptions: ['List', 'Icon', 'Stream'],
      iconSize: this.defaultViewOpts.iconSize,
      iconSizeOptions: ['Small', 'Medium', 'Large'],
      filtersOpen: false,
      columnsOpen: false,
      visibleColumns: this.defaultViewOpts.visibleColumns
    },
  };

  handleFilterSelect(index, selections){
    let newFilters = [...this.state.filterSelections];
    newFilters[index] = {...(newFilters[index]), selectedItems: selections};
    this.setState({filterSelections: newFilters, controller: {...this.state.controller, page: 1}});
  }

  addFilterSelect(index, optionId){
    let newFilters = [...this.state.filterSelections];
    let newSelection = [...newFilters[index].selectedItems];
    if(newSelection.indexOf(optionId) === -1){
      newSelection.push(optionId);
      newFilters[index] = {...(newFilters[index]), selectedItems: newSelection};
    }
    this.setState({tableView: {...this.state.tableView, filtersOpen: true}, filterSelections: newFilters, controller: {...this.state.controller, page: 1}});
  }

  addFilterSelectByName(filterName, optionId){
    let filter = this.filters.find(x => x.label === filterName);
    if(filter){
      filter.addFilterSelect(optionId);
    }
  }

  componentDidMount() {
    this.props.getFolderList(this.props.mindfile.id);
    this.props.getFilterValues(this.props.mindfile.id);
    this.props.setSelectedItems({});
  }

  fetchItems(fetchLocations=false) {
    if(!this.props.mindfile.id) return;
    this.setState({loading: true});
    let fetchFilters =  Object.fromEntries(this.filters.map((f,index) => f.enabled ? [f.key, this.state.filterSelections[index].selectedItems] : null).filter(item => !!item));
    this.props.getMindfileItems(this.state.pageKey, this.props.mindfile.id, this.state.controller, fetchFilters, this.state.mapBounds, () => {
      if(this.props.mindfileFilterValues.updated) {
        this.props.getFilterValues(this.props.mindfile.id, this.props.mindfileFilterValues.updated);
      }
      this.setState({loading: false});
    });
    if(fetchLocations){
      this.props.getMindfileItemLocations(this.props.mindfile.id, this.state.controller, fetchFilters);
    }
  }

  render() {
    return (
      <>
        <ItemsPage
          disableMap={true}
          viewingLevel={4}
          forceViewingLevel={true}
          title={this.state.title}
          displayCurrentMindfile={false}
          mindfileId={this.props.mindfile.id}
          itemList={this.props.itemsKey !== this.state.pageKey ? [] : this.props.items || []}
          itemCount={this.props.itemsKey !== this.state.pageKey ? 0 : this.props.filter_count}
          fetchItems={this.fetchItems.bind(this)}
          folderList={this.props.folderList}
          addFolder={this.props.addFolder}
          removeItems={this.props.removeItems.bind(this)}
          moveItems={this.props.moveItems.bind(this)}
          getMindfileItem={this.props.getMindfileItem.bind(this)}
          getMindfileItemsDetails={this.props.getMindfileItemsDetails.bind(this)}
          updateItemViewCount={this.props.updateItemViewCount.bind(this)}
          columns={this.columns}
          filters={this.filters}
          filterSelections={this.state.filterSelections}
          clearFilterSelections={() => this.setState({filterSelections: this.defaultFilters()})}
          addFilterSelectByName={this.addFilterSelectByName.bind(this)}
          mindfileFilterValues={this.props.mindfileFilterValues}
          selectedIds={this.state.selectedIds}
          setSelectedIds={(ids) => this.setState({selectedIds: ids})}
          selectedItems={this.props.selectedItems}
          setSelectedItems={this.props.setSelectedItems.bind(this)}
          controller={this.state.controller}
          setController={(prevStateFunc) => {
            return this.setState((prevState, props) => {
              return ({controller: {...prevStateFunc(prevState, props)}})
            })
          }}
          getMindfileItemLocations={this.props.getMindfileItemLocations.bind(this)}
          mapBounds={this.state.mapBounds}
          setMapBounds={(prevStateFunc) => {
            return this.setState((prevState, props) => {
              return ({controller: {...prevState.controller, page: 1}, mapBounds: prevStateFunc(prevState, props)})
            })
          }}
          loading={this.state.loading}
          setLoading={(isLoading) => this.setState({loading: isLoading})}
          viewOptsLoaded={this.state.viewOptsLoaded}
          bindViewOptions={
            <BindViewOptions
              pageKey={this.state.pageKey}
              parentState={this.state}
              parentProps={this.props}
              setParentState={this.setState.bind(this)}
              defaultViewOpts={this.defaultViewOpts}
              loaded={this.state.viewOptsLoaded}
              setLoaded={loaded => this.setState({viewOptsLoaded: loaded})}
            />
          }
          addButtons={this.state.tableView.addButtons}
          viewMode={this.state.tableView.viewMode}
          setViewMode={(e) => this.setState({tableView: {...this.state.tableView, viewMode: e.target.value}})}
          viewModeOptions={this.state.tableView.viewModeOptions}
          iconSize={this.state.tableView.iconSize}
          setIconSize={(e) => this.setState({tableView: {...this.state.tableView, iconSize: e.target.value}})}
          iconSizeOptions={this.state.tableView.iconSizeOptions}
          filtersOpen={this.state.tableView.filtersOpen}
          setFiltersOpen={(open) => this.setState({tableView: {...this.state.tableView, filtersOpen: open}})}
          columnsOpen={this.state.tableView.columnsOpen}
          setColumnsOpen={(open) => this.setState({tableView: {...this.state.tableView, columnsOpen: open}})}
          visibleColumns={this.state.tableView.visibleColumns}
          setVisibleColumns={(columns) => this.setState({tableView: {...this.state.tableView, visibleColumns: columns}})}
        />
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    itemsKey: state.mindfile_items?.pageKey,
    items: state.mindfile_items?.items || [],
    viewItem: state.viewItem,
    filter_count: state.mindfile_items?.filter_count || 0,
    canEdit: state.isCurrentMindfileContributor,
    mindfile: state.mindfile,
    folderList: state.folderList,
    mindfileFilterValues: state.mindfileFilterValues,
    selectedItems: state.selectedItems,
    primaryMindfile: !!state.mindfile && !!state.auth && state.mindfile.id === state.auth.mid
  };
}

const mapDispatchToProps = {
  getFolderList,
  getMindfileItems,
  getMindfileItemsDetails,
  getMindfileItemLocations,
  addFolder,
  removeItems,
  moveItems,
  getMindfileItem,
  getFilterValues,
  setSelectedItems,
  updateItemViewCount
};

export default connect(mapStateToProps, mapDispatchToProps)(SpacecastGlobalExplorer);
